import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { useReviewBodyContext } from '../../Context';
export function useSidebarCallbacks() {
  const $ = _c(10);
  const {
    setIsSidebarVisible
  } = useReviewBodyContext();
  const containerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      triggerOnce: false,
      threshold: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref: inViewRef,
    inView,
    entry
  } = useInView(t0);
  let t1;
  if ($[1] !== inViewRef) {
    t1 = node => {
      if (containerRef && "current" in containerRef) {
        containerRef.current = node;
      }
      inViewRef(node);
    };
    $[1] = inViewRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const setRefs = t1;
  let t2;
  let t3;
  if ($[3] !== entry || $[4] !== inView || $[5] !== setIsSidebarVisible) {
    t2 = () => {
      if (!entry) {
        return;
      }
      if (inView) {
        setIsSidebarVisible(false);
      } else {
        const rect = entry.boundingClientRect;
        if (rect.top < 0) {
          setIsSidebarVisible(true);
        } else {
          if (rect.bottom > window.innerHeight) {
            setIsSidebarVisible(false);
          }
        }
      }
    };
    t3 = [inView, entry, setIsSidebarVisible];
    $[3] = entry;
    $[4] = inView;
    $[5] = setIsSidebarVisible;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== setRefs) {
    t4 = {
      containerRef: setRefs
    };
    $[8] = setRefs;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}